/**
 * @file   : DestinationLayoutFacility.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 9/26/2018, 12:42:38 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import SimpleContainer from '../../../external/components/container/SimpleContainer'
import Cont, {
  ALIGN_CENTER,
  ALIGN_RIGHT,
} from '../../../external/components/layout/Cont'
import Divider from '../../../external/components/layout/Divider'
import Section, { SUB } from '../../../external/components/layout/Section'
import AIconAction from '../../../external/components/link/AIconAction'
import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import TextHoverable from '../../../external/components/link/TextHoverable'
import HTag from '../../../external/components/text/HTag'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import DestinationSummaryCard from './DestinationSummaryCard'

const DestinationLayoutInfo = ({
  theme,
  intl,
  destinationProducts,
  titleText = null,
  seeMoreText = null,
  seeMoreLink = null,
}) => {
  const getDestinationProductsUI = function () {
    const ui = destinationProducts.data.map((destinationProduct, i) => {
      let divider = null
      if (destinationProducts.data.length !== i + 1) {
        divider = <Divider />
      }

      return (
        <Cont key={i}>
          <DestinationSummaryCard
            intl={intl}
            theme={theme}
            destinationProduct={destinationProduct}
          />
          {divider}
        </Cont>
      )
    })

    return ui
  }

  const getHeaderUI = function () {
    let titleUI = null
    let sectionLinkUI = null
    let moreNearbyLink = null

    if (!isEmpty(seeMoreLink)) {
      moreNearbyLink = seeMoreLink
    } else if (
      !isUndefined(destinationProducts.nearbyURL) &&
      !isEmpty(destinationProducts.nearbyURL)
    ) {
      moreNearbyLink = destinationProducts.nearbyURL
    }

    if (!isEmpty(titleText)) {
      titleUI = (
        <Cont align={ALIGN_CENTER}>
          <HTag h2>
            <TextHoverable
              asSpan
              selected
              fontSizeType={2}
              fontFamily={'Figtree'}
              fontWeight={'600'}
            >
              {titleText}
            </TextHoverable>
          </HTag>
        </Cont>
      )
    }

    if (
      !isEmpty(seeMoreText) &&
      destinationProducts.data.length > 1 &&
      !isEmpty(moreNearbyLink)
    ) {
      sectionLinkUI = (
        <Cont align={ALIGN_RIGHT}>
          <AIconAction
            label={seeMoreText}
            faStyle={'fa-arrow-right'}
            isShowAsLink
            iconPos={'right'}
            {...createSimpleLinkProps(moreNearbyLink, false, true)}
          />
        </Cont>
      )
    }

    if (titleUI === null && sectionLinkUI === null) {
      return null
    }

    return (
      <Cont>
        <Section />
        <Section>
          <Section style={SUB}>
            {titleUI}
            {sectionLinkUI}
          </Section>
        </Section>
      </Cont>
    )
  }

  if (isUndefined(destinationProducts) || isEmpty(destinationProducts)) {
    return null
  }

  return (
    <SimpleContainer>
      <Cont>
        {getHeaderUI()}
        {getDestinationProductsUI()}
      </Cont>
    </SimpleContainer>
  )
}

DestinationLayoutInfo.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  destinationProducts: PropTypes.object,
  titleText: PropTypes.string,
  seeMoreText: PropTypes.string,
  seeMoreLink: PropTypes.string,
}

export default DestinationLayoutInfo
